import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DualListSelector from 'Components/DualListSelector';
import GDTableRecordsCount from 'Components/GDTable/GDTableRecordsCount';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import Search from 'Components/search/Search';
import mapInitialColumns from 'Utils/reports/mapInitialColumns';
import RefreshTimeBox from 'Components/RefreshTimeBox/RefreshTimeBox';
import { getReportListTranslations } from 'Utils/languages';
import { getExportTypes, getFileTypes } from '../constants/exportList';
import './GDTableHeader.scss';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import LeftPointerIcon from 'Components/icons/left-pointer-icon/LeftPointerIcon';
import FileExport from 'Components/file-export/FileExport';
import { loadState } from '../../../../app/src/store/browserStorage';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import { VITE_EXPORT_FILE_ROW_LIMIT } from 'Constants/appEnvConstants'
import { COLORS } from "Constants/BIDashboardConstants"
class GDTableHeader extends Component {
  constructor(props) {
    super(props);

    this.translationsList = getReportListTranslations();
    const initialColumns = mapInitialColumns(this.props.columns);
    this.state = {
      activeColumns: initialColumns.filter((column) => column.required || column.isSelected && column.displayType !== 'ICON'),
      availableColumns: initialColumns.filter((column) => !column.isSelected && !column.isRequired && column.description !== '' && column.displayType !== 'ICON'),
      availableFilter: '',
      activeFilter: '',
      currentActiveColumns: initialColumns.filter((column) => column.required || column.isSelected),
      fileExportTranslations: {
        exportReport: this.translationsList.exportReport,
        cancelText: this.props.translations.cancel,
        exportText: this.props.translations.export,
        exportTypesTitle: this.props.translations.exportTypesTitle,
        fileNameLabel: this.props.translations.fileNameLabel,
        fileTypesTitle: this.props.translations.fileTypesTitle,
        header: this.props.translations.header,
        hugeExportMessage: this.props.translations.hugeExportMessage,
        emptySavedFilter: {
          title: 'A Saved Filter is required',
          subTitle: 'It looks like you don\'t have any saved filters to export this report.',
        },
      },
      selectedExportType: {},
      selectedFileType: {},
    };
  }

  componentWillReceiveProps(newProps) {
    const initialColumns = mapInitialColumns(newProps.columns);
    const newActiveColumns = initialColumns.filter((column) => column.required || column.isSelected && column.displayType !== 'ICON');
    const newAvailableColumns = initialColumns.filter((column) => !column.isSelected && !column.isRequired && column.description !== '' && column.displayType !== 'ICON');
    if ((this.state.activeColumns.length === 0) || (this.state.activeColumns.length == newActiveColumns.length &&
      this.state.availableColumns.length == newAvailableColumns.length)) {
      this.setState({
        activeColumns: newActiveColumns,
        availableColumns: newAvailableColumns,
      });
    }
  }

  updateVisibleColumns = () => {
    this.child.handleOnSubmit();
  }

  handleOnApplyActiveColumns = (newAvailableColumns, newActiveColumns) => {
    this.setState({
      availableColumns: newAvailableColumns,
      activeColumns: newActiveColumns,
      currentActiveColumns: newActiveColumns,
    }, () => {
      this.props.updateVisibleColumns(newActiveColumns);
    });
  }

  handleOnUpdateActiveColumns = (columns) => {
    this.setState({
      currentActiveColumns: columns,
    });
  }

  cancelExport = () => {
    this.setState({
      selectedExportType: {},
      selectedFileType: {},
    });

    const body = document.querySelector('body');
    const e = document.createEvent('MouseEvents');
    e.initEvent('mousedown', true, true);
    body.dispatchEvent(e);
  }

  exportAction = (fileName, exportType, fileType, reportId, updatedFilters, hugeExportMsg) => {
    const body = document.querySelector('body');
    const e = document.createEvent('MouseEvents');
    e.initEvent('mousedown', true, true);
    body.dispatchEvent(e);

    const exportOptions = {
      exportType,
      fileType,
      fileName,
      hugeExportMsg,
    };

    this.props.exportAction(exportOptions);

    this.setState({
      selectedExportType: {},
      selectedFileType: {},
    });
  }

  render() {
    const wrapperClass = classnames('gd-table__header', {
      [this.props.extraClass]: this.props.extraClass,
    });
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;

    const exportList = getExportTypes();
    const fileTypes = getFileTypes(userPermission);
    return (
      <div>
        <div className={wrapperClass} style={this.props.reportName == 'MRE' ? { backgroundColor: "#DDDDDD", padding: "20px 25px", minHeight: "57px" } : {}}>
          {this.props.showBackToReport &&
            <div className="return-to-reports">
              <LinkInlineButton action={this.props.routeToPreviousPage}>
                <LeftPointerIcon /> Back To Reports
              </LinkInlineButton>

            </div>}
          <div className="gd-table__header--left">
            {this.props.titleRequired && <span><h2 className="gd-table__header-ReletedCaseTitle">{this.props.tableName ? this.props.tableName : this.props.title}
              <span style=
                {{ fontSize: '14px', color: COLORS.oneGp.charcoal, display: this.props?.merchantDetail == null ? 'none' : 'inline' }}>  &nbsp;  {'Results for'} {this.props?.merchantDetail?.cardNumber.replace(/(X)/ig || /(x)/ig, '*')}  &nbsp;
                <span className="gd-color-coded-cell" style={{ paddingLeft: '2px', paddingRight: '2px' }}><span className="gd-color-coded-cell__indicator" style=
                  {{ display: 'inline-block', height: '7px', width: '7px', marginBottom: '5px', background: '#F5A623' }} ></span></span>{this.props?.merchantDetail?.merchantName} &nbsp; {this.props?.merchantDetail?.merchantNumber} </span>
            </h2> </span>}
            {this.props.reportName == 'MRE' && this.props.isMyruleTable &&
              <h4 style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "12px", color: "#646264", fontStyle: "italic", marginLeft: "-6px" }}>{this.props.userActiveRuleCount === 0 ? '0' : this.props.userActiveRuleCount} {this.props.translations.active} {this.props.userInactiveRuleCount === 0 ? '0' : this.props.userInactiveRuleCount} {this.props.translations.inActive} </h4>}
            {this.props.informationBubbleText &&
              <InformationBubble
                id={this.props.title}
                info
                tooltipContent={this.props.informationBubbleText}
                reportName={this.props.title}
              />
            }
            {this.props.reportName == 'MRE' && this.props.isOtherExistingRuleTable &&
              <h4 style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "12px", color: "#646264", fontStyle: "italic", marginLeft: "6px" }}>{this.props.otherActiveRuleCount === 0 ? '0' : this.props.otherActiveRuleCount} {this.props.translations.active} {this.props.otherInactiveRuleCount === 0 ? '0' : this.props.otherInactiveRuleCount} {this.props.translations.inActive} </h4>}
            {this.props.recordCountRequired === false ? null : <GDTableRecordsCount
              totalRecords={this.props.totalRecords}
              text={this.props.recordsCountText}
              currentPage={this.props.currentPage}
              recordsShown={this.props.recordsShown}
              isNextPage={this.props.isNextPage}
              id={`${this.props.title}_GDTableRecordsCount`}
            />
            }
            {this.props.timeBoxData.isRefreshRequired &&
              <RefreshTimeBox
                timeBoxData={this.props.timeBoxData}
                refreshTimeFeed={this.props.refreshTimeFeed}
              />}
          </div>
          <div className="gd-table__header--right">
            {this.props.canSearch && <span className="gd-table__header-search">
              <Search
                filterText={this.props.filterText}
                onChange={this.props.onSearchChange}
              />
            </span>}
            {this.props.showCollapseExpandButton && this.props.canManageColumns && this.state.activeColumns.length > 0 && <OptionBoxPopup

              id={(this.props.isrelatedSearchLoaded === true ? `${this.props.title}_OptionBoxPopup relatedSrch ` : (this.props.tableCss == "tableAppSearch" ? `${this.props.title}_OptionBoxPopup relatedSrch ` : `${this.props.title}_OptionBoxPopup`))}
              applyAction={this.updateVisibleColumns}
              applyDisabled={this.state.currentActiveColumns.length < 1}
              triggerText={this.props.translations.columns}
              optionalFooter
              translations={{
                cancel: this.props.translations.cancel,
                apply: this.props.translations.apply,
              }}
            >
              <DualListSelector
                id={`${this.props.title}_DualListSelector`}
                onRef={(ref) => (this.child = ref)}
                availableColumns={this.state.availableColumns}
                activeColumns={this.state.activeColumns}
                handleOnApplyActiveColumns={this.handleOnApplyActiveColumns}
                handleOnUpdateActiveColumns={this.handleOnUpdateActiveColumns}
                doubleWidth={false}
                showVisibility={false}
                extraClass=" "
                isDialog
                translations={this.props.translations}
              />
            </OptionBoxPopup>}
            {
              this.props.exportAction !== null && this.props.showCollapseExpandButton &&
              <div className="file-export-wrapper" style={!this.props.canExport ? { display: 'none' } : {}}>
                <OptionBoxPopup
                  id={(this.props.isrelatedSearchLoaded === true ? `${this.props.title}_OptionBoxPopup relatedSrch ` : (this.props.tableCss == "tableAppSearch" ? `${this.props.title}_OptionBoxPopup relatedSrch ` : `${this.props.title}_OptionBoxPopup`))}
                  extraClass="file-export-wrapper"
                  triggerText={this.props.exporting ? `${this.props.translations.exporting}...` : `${this.props.translations.export}`}
                >
                  {<FileExport
                    cancelAction={this.cancelExport}
                    exportAction={this.exportAction}
                    exportTypes={exportList}
                    fileTypes={fileTypes}
                    selectedFileType={this.props.selectedFileType}
                    selectedExportType={this.props.selectedExportType}
                    selectOption={this.props.selectOption}
                    suggestedFileName={this.props.exportFileName}
                    translations={this.state.fileExportTranslations}
                    hugeExportMsg={this.props.totalRecords > VITE_EXPORT_FILE_ROW_LIMIT}
                  />}
                </OptionBoxPopup>
              </div>
            }
          </div>
        </div>
        <div className="gd-table__header--left queue-desc">
          <span>
            {this.props.queueDesc}
          </span>
        </div>
      </div>

    );
  }
}

GDTableHeader.propTypes = {
  canExport: PropTypes.bool,
  canManageColumns: PropTypes.bool,
  canSearch: PropTypes.bool,
  columns: PropTypes.array,
  currentPage: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  exportAction: PropTypes.func,
  exporting: PropTypes.bool,
  extraClass: PropTypes.string,
  filterText: PropTypes.string,
  isNextPage: PropTypes.bool,
  onSearchChange: PropTypes.func,
  recordsCountText: PropTypes.object.isRequired,
  recordsShown: PropTypes.number,
  report: PropTypes.object.isRequired,
  selectOption: PropTypes.func,
  selectedExportType: PropTypes.object,
  selectedFileType: PropTypes.object,
  title: PropTypes.string.isRequired,
  tableName: PropTypes.string,
  totalRecords: PropTypes.number.isRequired,
  translations: PropTypes.object,
  updateVisibleColumns: PropTypes.func,
  callOnBoardContainer: PropTypes.bool,
  timeBoxData: PropTypes.object,
  showBackToReport: PropTypes.bool,
  exportFileName: PropTypes.string,
  reportName: PropTypes.string,
  informationBubbleText: PropTypes.string,
  merchantDetail: PropTypes.object,
  showCollapseExpandButton: PropTypes.bool,
};

GDTableHeader.defaultProps = {
  canExport: true,
  canManageColumns: false,
  canSearch: false,
  columns: [],
  exportAction: null,
  exporting: false,
  extraClass: '',
  filterText: '',
  onSearchChange: () => { },
  isNextPage: false,
  recordsShown: 25,
  selectOption: () => { },
  selectedFileType: null,
  selectedExportType: null,
  translations: {},
  updateVisibleColumns: () => { },
  callOnBoardContainer: true,
  timeBoxData: {},
  showBackToReport: false,
  exportFileName: '',
  merchantDetail: null,
  showCollapseExpandButton: true,
  userInactiveRuleCount: 0,
  userActiveRuleCount: 0,
  isMyruleTable: false,
  otherActiveRuleCount: 0,
  otherInactiveRuleCount: 0,
  isOtherExistingRuleTable: false,
  reportName: '',
};

export default GDTableHeader;
